import { Link } from "react-router-dom";

const LegalFooter = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-10" data-testid="legal-footer">
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex items-center justify-center gap-4 text-xs text-slate-500">
        <Link to="/legal" className="hover:text-sky-600 transition-colors" data-testid="footer-legal-link">
          Mentions légales
        </Link>
        <span className="text-slate-300">|</span>
        <Link to="/privacy" className="hover:text-sky-600 transition-colors" data-testid="footer-privacy-link">
          Politique de confidentialité
        </Link>
      </div>
    </footer>
  );
};

export default LegalFooter;
